import { usePointsTransfer } from './hooks/usePointsTransfer';
import { PointsTransferLogs } from './table';

const PointsTransfer = () => {
  const { pointsTransferdata } = usePointsTransfer();
  return <PointsTransferLogs data={pointsTransferdata} />;
};

export default PointsTransfer;
